import { render, staticRenderFns } from "./primary-day-automation.vue?vue&type=template&id=2cd75756"
import script from "./primary-day-automation.vue?vue&type=script&lang=js"
export * from "./primary-day-automation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports